import { useTaskStore } from '@prodelio/modules/tasks/state/useTaskStore';

export const getTask = (taskId: string) =>
  useTaskStore.getState().tasks.find((task) => task.id === taskId);
